import { TMixpanelProperties } from '@aqx-core/common/mixpanel/types';
import {
  getOrderBuySellType,
  mapOrderBuySellTypeToTextUpperCase,
  mapOrderTypeToOrderTypeLabel
} from '@aqx-core/common/utils/order';

import { IMixpanelChartTrackingProps } from '../../chart/type';
import { EMixpanelProperties } from '../../types';
import { getMixpanelSLTPType } from './utils';

class ChartTrackingHelper {
  public createChartTrackingProperties = ({
    symbol,
    orderId,
    orderType,
    SLTPType
  }: IMixpanelChartTrackingProps): TMixpanelProperties => {
    return {
      [EMixpanelProperties.SYMBOL]: symbol ?? '-',
      [EMixpanelProperties.ORDER_ID]: orderId ?? '-',
      [EMixpanelProperties.ORDER_TYPE]:
        orderType !== undefined || orderType !== null ? mapOrderTypeToOrderTypeLabel(orderType) : '-',
      [EMixpanelProperties.DIRECTION]:
        orderType !== undefined || orderType !== null
          ? mapOrderBuySellTypeToTextUpperCase(getOrderBuySellType(orderType), 'en_GB')
          : '-',
      [EMixpanelProperties.SLTP_TYPE]: getMixpanelSLTPType(SLTPType) ?? '-'
    };
  };
}

const chartTrackingHelper = new ChartTrackingHelper();
export default chartTrackingHelper;
